import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getWasteHistory(params) {
  return request({
    url: '/wasteHistory',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
  });
}

export function getWasteTotal(params) {
  return request({
    url: '/wasteHistory/total',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
  });
}

export function getWasteAnalytics(params) {
  return request({
    url: '/eventAnalytic/materials',
    method: 'get',
    data: {
      className: 'DetailedWasteHistoryProjection',
      ...buildApiPayload({ payload: params, dateEndKeys: ['endEventTime'] }),
    },
  });
}

export function getWasteReport(params) {
  return request({
    url: '/wasteHistory/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}
